/**
 *
 * Custom lazy image loader.
 * Takes into account the fact that many big images on this site are loaded as background images
 *
 * If you want to use this, create either of these types of elements, with noscript alternatives.
 *
 * The noscript alternatives aren't required, but if they are not supplied, users with scripting off will never be able to load the image
 *
 * IMG tag:
 *
 * <img class="lazy" lazy-src="myimage.png" alt="ok" />
 * <noscript><img src="myimage.png" alt="ok" /></noscript>
 *
 * or
 * Background Image:
 *
 *  <div class="lazy" lazy-background-image="url('myimage.png')" style="background-repeat: no-repeat; background-size:100% 100%;">
 *    some stuff
 *  </div>
 *  <noscript>
 *  <div style="background-repeat: no-repeat; background-size:100% 100%; background-image:url('myimage.png');">
 *    some stuff
 *  </div>
 *  </noscript>
 *
 */

jQuery(document).ready(function ($) {
  /**
   * PROPERTIES
   */
  var lazyClassName = "lazy";
  var lazySelector = '.' + lazyClassName;
  var backgroundImageAttr = "lazy-background-image";
  var srcAttr = "lazy-src";
  // Try reevaluating available lazies after a period
  var reinitializeTimeout = 4000;
  // Start loading images n pixels before they are visible
  var preloadMargin = 300;

  /**
   * PRIVATE METHODS
   */
  function init() {
    initializeObserver($(lazySelector));
    initializeMutationObserver();
  }

  // For all given elements, add an intersection observer.
  // Load image when intersection is found, and remove the obserer
  function initializeObserver(lazies) {
    var intersectionOptions = {
      rootMargin: preloadMargin + 'px'
    };
    var intersectionObserver = new IntersectionObserver(function (entries, observer) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (entry.isIntersecting) {
            loadImage(entry.target);
            observer.unobserve(entry.target);
          }
        }
      },
      intersectionOptions
    );
    lazies.each(function () {
      intersectionObserver.observe(this);
    });
  }

  // Watch for dom changes. If any added elements are the correct ones, add an intersection observer
  function initializeMutationObserver() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.addedNodes && mutation.addedNodes.length) {
          var observableElements = $(mutation.addedNodes).find(lazySelector);
          observableElements.each(function () {
            initializeObserver($(this));
          });
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function loadImage(cur) {
    var el = $(cur);
    el.removeClass(lazyClassName);
    // Load the background image if indicated
    if (el.is("[" + backgroundImageAttr + "]")) {
      el.css("background-image", el.attr(backgroundImageAttr));
      // Load the img src if indicated
    } else if (el.is("[" + srcAttr + "]")) {
      el.attr("src", el.attr(srcAttr));
    }
  }

  /**
   *
   * INITIALIZATION
   *
   */
  init();
  setTimeout(init, reinitializeTimeout);
});
